// extracted by mini-css-extract-plugin
export default {"mainFrame":"Home_mainFrame__2WxWV","caption":"Home_caption__LlnUv"};